<template>
  <div class="preview"
       :class="[
         invisible ? 'preview--invisible' : 'preview--visible',
         directionController
       ]"
  >
    <div class="content-ctn">
      <div class="thumbnail"
           @click="openProject(slug)"
           @mouseenter="$store.dispatch($CHANGE_CURSOR_STATE, 'pointer')"
           @mouseleave="$store.dispatch($CHANGE_CURSOR_STATE, 'default')"
      >
        <slot />
      </div>
      <div class="prj-data-ctn">
        <div class="prj-data">
          <div class="text-wrapper">
            <h3 class="prj-data__name">
              {{ name }}
            </h3>
          </div>
          <div class="text-wrapper">
            <p class="prj-data__type">
              {{ type }}
            </p>
          </div>
          <!--          <div class="text-wrapper">-->
          <!--            <p class="prj-data__year">-->
          <!--              {{ year }}-->
          <!--            </p>-->
          <!--          </div>-->
        </div>
        <div class="access-btn-ctn">
          <div class="divider preview-divider mb-3" />
          <main-btn :label="buttonLabel" :is-from-behance="projectType === 'behance'" @click="openProject(slug)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainBtn from '@/components/main-btn'
export default {
  name: 'Preview',
  components: {
    MainBtn
  },
  props: {
    textBackground: String,
    name: String,
    type: String,
    year: String,
    projectType: {
      type: String,
      required: true,
      validator: value => ['presentation', 'behance', 'external'].includes(value)
    },
    invisible: Boolean,
    externalUrl: String
  },
  computed: {
    buttonLabel () {
      if (this.projectType === 'behance') return 'Ver no Behance'
      if (this.projectType === 'external') return 'Ver site'
      return 'Abrir projeto'
    },
    slug () {
      let str = this.name
      str = str.replace(' ', '-')
      return str.toLowerCase()
    },
    lastScrollDirection () {
      return this.$store.state.lastScrollDirection
    },
    directionController () {
      if (this.invisible) {
        return `preview--${this.lastScrollDirection}`
      } else {
        if (this.lastScrollDirection === 'right') return 'preview--left'
        else return 'preview--right'
      }
    }
  },
  methods: {
    openProject (slug) {
      if (this.projectType === 'presentation') this.$router.push({ name: slug })
      else window.open(this.externalUrl)
    }
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities
/* purgecss start ignore */

@mixin transition-in($duration, $delay)
  transition: transform #{$duration} #{$delay} cubic-bezier(.1,.58,.43,.87)

@mixin transition-out($duration)
  transition: transform #{$duration} .1s cubic-bezier(.1,.58,.43,.87)

$transition-out: transform .5s .1s cubic-bezier(.1,.58,.43,.87)
$transition-in: transform .3s .4s cubic-bezier(.1,.58,.43,.87)
$transition-divider: transform .5s .3s cubic-bezier(.09,.8,.33,.95)
$project-small-width: 80vw

.preview
  @apply relative flex items-center justify-center font-sans h-screen w-screen
  &--invisible
    .text-wrapper
      @include transition-out(.3s)
      @screen lg
        @include transition-out(.5s)
    .prj-data
      &__name, &__type, &__year
        @include transition-out(.3s)
        @screen lg
          @include transition-out(.5s)
    .preview-divider
      transform: scaleX(0)
      transition: $transition-divider
  &--right
    .text-wrapper
      @apply -translate-x-100
    .prj-data
      &__name, &__type, &__year
        @apply translate-x-100
  &--left
    .text-wrapper
      @apply translate-x-100
    .prj-data
      &__name, &__type, &__year
        @apply -translate-x-100
  &--visible
    .text-wrapper
      @apply translate-x-0
      @include transition-in(.5s, .1s)
      @screen sm-l
        @include transition-in(.5s, .3s)
      @screen lg
        @include transition-in(.3s, .4s)
    .prj-data
      &__name, &__type, &__year
        @apply translate-x-0
        @include transition-in(.5s, .1s)
        @screen sm-l
          @include transition-in(.5s, .3s)
        @screen lg
          @include transition-in(.3s, .4s)
    .preview-divider
      transform: scaleX(1)
      transition: $transition-divider

.access-btn-ctn
  @apply text-center mt-3
  @screen md
    @apply text-left mt-8

.content-ctn
  @apply absolute inline-flex flex-col items-center relative z-10
  @screen sm-l
    @apply flex-row
  @screen md
    @apply flex-row

.prj-data-ctn
  @apply flex flex-col mt-3
  width: $project-small-width
  @screen sm-l
    @apply ml-3
    width: initial
  @screen md
    width: initial
    @apply ml-5 mt-0

.prj-data
  @apply inline-flex flex-col items-start
  &__name
    @apply inline-block text-4xl text-black
    @screen md
      @apply text-6xl
  &__type
    @apply inline-block text-xl mt-1
    @screen md
      @apply text-3xl
  &__year
    @apply inline-block text-xl text-grey-darkest
    @screen md
      @apply text-3xl

.text-wrapper
  @apply overflow-hidden

.thumbnail
  @apply relative rounded-lg shadow-lg overflow-hidden h-56 mt-2
  width: $project-small-width
  @screen sm-l
    @apply w-64
  @screen md
    @apply h-160 w-80 mt-0
/* purgecss end ignore */
</style>
